import { Swiper, SwiperSlide } from 'swiper';
import { Navigation, Pagination, A11y, Keyboard, Autoplay } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function (event) {

	const blogSwiperElements = document.querySelectorAll(".blogSwiper");

	if (blogSwiperElements.length > 0) {

		var slidesPerView = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-slide');
		var autoplay = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-autoplay');
		var loop = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-loop');
		var speed = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-speed');
		var navigation = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-navigation');

		var navigation_obj = {};
		if (navigation) {
			navigation_obj = {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			}
		} else {
			var element = document.getElementsByClassName('swiper-button-next');
			if (element.length > 0) {
				element[0].parentNode.removeChild(element[0]);
			}

			element = document.getElementsByClassName('swiper-button-prev');
			if (element.length > 0) {
				element[0].parentNode.removeChild(element[0]);
			}
		}

		const swiper = new Swiper(".blogSwiper", {
			modules: [Navigation, Pagination, A11y, Keyboard, Autoplay],

			slidesPerView: (slidesPerView ? slidesPerView : 2),
			spaceBetween: 24,
			loop: (loop ? loop : true),
			speed: (speed ? speed : 2000),

			autoplay: (autoplay ? {
				delay: (speed ? speed : 2500),
				disableOnInteraction: false,
			} : false),

			navigation: navigation_obj,

			pagination: {
				el: ".swiper-pagination",
				clickable: true,

				// 🔥 Custom bullet rendering (segmented bars)
				renderBullet: function (index, className) {
					return `
						<span class="${className}">
							<span class="bullet-progress"></span>
						</span>
					`;
				},
			},

			autoHeight: true,
			mousewheel: true,

			keyboard: {
				enabled: true,
			},

			breakpoints: {
				100: { slidesPerView: 1 },
				768: { slidesPerView: 1 },
				1024: { slidesPerView: (slidesPerView ? slidesPerView : 1) },
			},

			on: {
				init: function () {
					startProgress(this);
				},
				slideChangeTransitionStart: function () {
					resetProgress(this);
				},
				slideChangeTransitionEnd: function () {
					startProgress(this);
				}
			}
		});

		/* ------------------------------
		   Progress Animation Functions
		--------------------------------*/

		function startProgress(swiperInstance) {

			if (!swiperInstance.params.autoplay) return;

			const bullets = swiperInstance.pagination.bullets;
			const activeIndex = swiperInstance.realIndex;

			bullets.forEach((bullet, index) => {

				const fill = bullet.querySelector(".bullet-progress");
				if (!fill) return;

				if (index === activeIndex) {
					fill.style.transition = `width ${swiperInstance.params.autoplay.delay}ms linear`;
					fill.style.width = "100%";
				}
			});
		}

		function resetProgress(swiperInstance) {

			const bullets = swiperInstance.pagination.bullets;

			bullets.forEach((bullet) => {

				const fill = bullet.querySelector(".bullet-progress");
				if (!fill) return;

				fill.style.transition = `width ${swiperInstance.params.autoplay.delay}ms linear`;
				fill.style.width = "0%";
			});
		}
	}
});
